<template>
    <div>
        <loader v-if="!survey || transitioning" />
        <div v-else
            id="survey-request-template"
        >
            <div class="header">
                <label>{{survey.title}}</label>
                <small class="tracker">{{(current_step + 1)}}/{{survey.questions.length}}</small>
            </div>
            <div class="question" v-if="current_question" >
                <label>
                    {{ question_text }}
                    <i><small>{{ (current_question.required ? "" : "(Optional)") }}</small></i>
                </label>
                <star-select-input v-if="current_question.star_rating" 
                    v-model="responses[current_question.slug]" 
                    :stars="current_question.star_rating.max_stars" 
                />
                <textarea v-else-if="current_question.free_text"
                    v-model="responses[current_question.slug]" 
                    class="comment"
                    :maxlength="current_question.free_text.max_length"
                />
                <survey-multiple-choice-input v-else-if="current_question.multiple_choice"
                    v-model="responses[current_question.slug]" 
                    :multiple="current_question.multiple_choice.is_multiple_choice"
                    :options="current_question.multiple_choice.options"
                />
            </div>
            <div class="footer"> 
                <button v-if="current_step > 0"
                    class="btn previous"
                    @click="previous"
                >
                    Previous
                </button>
                <button v-if="current_step != last_step"
                    class="btn next"
                    @click="next"
                >
                    Next
                </button>
                <button v-if="current_step == last_step"
                    class="btn btn-primary submit"
                    @click="submit"
                >
                    Submit
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import StarSelectInput from "@/components/inputs/StarSelectInput.vue";
import InputTextArea from "@/components/inputs/InputTextArea.vue";
import Card from "@/components/Card.vue";
import Loader from "@/components/Loader.vue";
import SurveyMultipleChoiceInput from './components/SurveyMultipleChoiceInput.vue'

export default {
    components: {
        StarSelectInput,
        InputTextArea,
        Card,
        Loader,
        SurveyMultipleChoiceInput
    },
    props: {
        survey: {
            type: Object,
            required: true
        },
        interpolations: {
            type: Object,
            required: false,
            default: () => ({})
        },
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            transitioning: false,
            responses: this.value,
            current_step: 0,
        }
    },
    watch:{
        value() {
            this.responses = this.value
        }
    },
    computed: {
        current_question() {
            if (this.survey && this.survey.questions && this.survey.questions.length > this.current_step)
                return this.survey.questions[this.current_step]
            return null
        },
        question_text() {
            let text = this.current_question.question_text
            for(const key in this.interpolations) {
                const index = text.indexOf(`{{${key}}}`)
                if(index > -1) {
                    text = text.substring(0, index)
                        + this.interpolations[key]
                        + text.substring(index + key.length + 4)
                }
            }

            return text
        },
        is_valid() {
            return !this.current_question.required 
                || this.responses[this.current_question.slug]
        },
        last_step() {
            return this.survey.questions.length - 1
        }
    },
    methods: {
        previous() {
            this.current_step--;
        },
        next() {
            if (!this.is_valid)
                return;

            this.emit_responded(() => setTimeout(() => this.current_step++))
        },
        submit() {
            if (!this.is_valid)
                return;

            this.emit_responded(this.emit_submit)
        },
        emit_responded(onsuccess) {
            this.transitioning = true

            const payload = { 
                question: this.current_question, 
                answer: this.responses[this.current_question.slug],
                next: () =>{
                    onsuccess()
                    this.transitioning = false
                },
                interupt: () => {
                    this.transitioning = false
                }
            }

            this.$emit('responded',payload)
        },
        emit_submit(){
            this.$emit('submit', this.responses)
        }
    }
}
</script>
<style lang="scss" scoped>
#survey-request-template {
    .header {
        display: flex;

        label {
            font-size: 12px;
            color: $green;
            letter-spacing: 0.1rem;
            text-transform: uppercase;
        }

        .tracker {
            text-align: right;
            flex: 1;
        }
    }

    .question {
        width: 100%;
        margin-bottom: 25px;
    }

    .footer {
        width: 100%;
        text-align: right;

        .btn:not(.btn-primary) {
            background-color: $dark-blue;
            border-color: $green;
            color: $green;
            margin-right: 5px;
        }
    }

    .comment {
        width: 100%;
        min-height: 150px;
        resize: none;
    }
}
</style>